import type { VpIconName } from '@vtmn-play/react';
import { InteractionTags } from '~/model/InteractionType';

export const defineIconValue = (tag: InteractionTags): VpIconName => {
  switch (tag) {
    case InteractionTags.EVENT:
      return 'calendar-check';
    case InteractionTags.INTERVIEW:
      return 'user';
    case InteractionTags.PRODUCT_TEST_ONSITE:
      return 't-shirt';
    case InteractionTags.PRODUCT_TEST_REMOTE:
      return 'home';
    case InteractionTags.ROUNDTABLE:
      return 'group';
    case InteractionTags.SURVEY_FEEDBACK:
    case InteractionTags.SURVEY_QUANTITATIVE:
      return 'question';
    case InteractionTags.USER_TEST:
      return 'lightning';
    case InteractionTags.WORKSHOP:
      return 'lightbulb';
    case InteractionTags.DISCUSSION:
    default:
      return 'message';
  }
};
